

export type TypeAppIcon = 'close'
| 'arrow--left'
| 'search'
| 'cross'
| 'close--modal'
| 'burger'
| 'download'
| 'clear'

export const getIcon = (iconName: TypeAppIcon) => ({
  type: 'svg' as const,
  src: `/images/svg/i--${iconName}.svg`,
  alt: iconName + ' icon',
  size: { width: 40, height: 40 },
  content_type: 'image/svg+xml'
})
